<script>
  import AjaxForm from './AjaxForm';


  export default {
    mixins: [AjaxForm],
    props : {
      api   : String,
      method: String,
    },
    data() {
      return {
        model: {
          name  : '',
          tel   : '',
          accept: true,
        },
      };
    },
  };
</script>

<template>
  <div class="form" :class="{form_state_status: form.status!==null}">
    <div class="form__loading form-loading" v-if="form.loading"></div>
    <div class="form__form">
      <p>Заполните небольшую форму и наш менеджер свяжется с вами в ближайшее время</p>

      <vue-form
          action="#"
          :method="method"
          :data-action="api"
          :state="state"
          @submit.prevent="formSubmit"
      >

        <!--suppress CommaExpressionJS -->
        <input v-for="(value, name) in form.hiddenFields" :name="name" :value="value" type="hidden">

        <div class="form-group">
          <validate class="inputbox">
            <input class="inputbox__input form-control"
                v-model="model.name"
                required name="name" type="text" placeholder="Ваше имя *">
            <field-messages v-if="state.$submitted && state.name.$invalid" class="inputbox__state form-state"
                name="name">
              <div class="form-state__message" slot="required">{{messages.required}}</div>
            </field-messages>
          </validate>
        </div>
        <div class="form-group">
          <validate class="inputbox">
            <input
                class="inputbox__input-field form-control"
                v-model="model.tel"
                required name="tel" type="tel" placeholder="Телефон *">
            <field-messages v-if="state.$submitted && state.tel.$invalid" class="inputbox__state form-state" name="tel">
              <div class="form-state__message" slot="required">{{messages.required}}</div>
            </field-messages>
          </validate>
        </div>
        <div class="form-group">
          <validate>
            <div class="checkbox">
              <field-messages v-if="state.$submitted && state.accept.$invalid" class="checkbox__state form-state"
                  name="accept">
                <div class="form-state__message" slot="required">{{messages.accept}}</div>
              </field-messages>
              <label>
                <input name="accept" v-model="model.accept" type="checkbox" checked required>
                <i></i>
                <span>
                Принимаю <a href="#" class="link-dotted">политику конфиденциальности</a> и
                <a href="#" class="link-dotted">пользовательское соглашение</a>
              </span>
              </label>
            </div>
          </validate>
        </div>
        <div class="form-group">
          <button class="btn btn_block btn_small" type="submit" :disabled="!(model.accept)">
            Перезвоните мне
          </button>
        </div>
      </vue-form>
    </div>
    <transition name="status">
      <form-status class="form__status" v-if="form.status!==null"
          @close="hideStatus()"
          :status="form.status"
          :message="form.message"
      ></form-status>
    </transition>
  </div>
</template>



// WEBPACK FOOTER //
// CallbackForm.vue?011efc14